import { TrackProcessList } from "@/components/audiolab/admin/TrackProcessList";
import { TrackProcessStepList } from "@/components/audiolab/admin/TrackProcessStepList";
import ContainerWrapper from "@/components/ui/ContainerWrapper";
import { APP_VERSION } from "@/lib/config/env-var.config";
import { Button, DropdownMenu, Flex, Tabs, Text } from "@radix-ui/themes";
import { createFileRoute, Link } from "@tanstack/react-router";
import {
  HiOutlineStar,
  HiOutlineTrash,
  HiOutlineUserCircle,
  HiOutlineUsers,
} from "react-icons/hi2";

function AdminPage() {
  return (
    <ContainerWrapper className="py-8">
      <Flex direction="column" gap="6">
        <Flex justify="between" align="center">
          <Flex direction="column" gap="2">
            <Text size="8" weight="bold">
              Audiolab Administration
            </Text>
            <Text size="4" color="gray">
              Manage tracks, monitor performance, and oversee content
            </Text>
            <Text size="2">Version: {APP_VERSION}</Text>
          </Flex>
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <Button variant="soft">
                Admin Actions
                <DropdownMenu.TriggerIcon />
              </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content
              variant="soft"
              color="gray"
              className="min-w-[190px] rounded-[10px]"
            >
              <DropdownMenu.Item asChild>
                <Link to="/admin/users" className="cursor-pointer">
                  <Flex align="center" gap="2">
                    <HiOutlineUsers className="w-4 h-4" />
                    Users
                  </Flex>
                </Link>
              </DropdownMenu.Item>
              <DropdownMenu.Item asChild>
                <Link to="/admin/featured-albums" className="cursor-pointer">
                  <Flex align="center" gap="2">
                    <HiOutlineStar className="w-4 h-4" />
                    Featured Albums
                  </Flex>
                </Link>
              </DropdownMenu.Item>
              <DropdownMenu.Item asChild>
                <Link to="/admin/impersonate" className="cursor-pointer">
                  <Flex align="center" gap="2">
                    <HiOutlineUserCircle className="w-4 h-4" />
                    Impersonate User
                  </Flex>
                </Link>
              </DropdownMenu.Item>
              <DropdownMenu.Separator />
              <DropdownMenu.Item asChild color="red">
                <Link to="/admin/delete-user" className="cursor-pointer">
                  <Flex align="center" gap="2">
                    <HiOutlineTrash className="w-4 h-4" />
                    Delete User
                  </Flex>
                </Link>
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </Flex>

        <Tabs.Root defaultValue="tab1">
          <Tabs.List className="TabsList" aria-label="Manage your account">
            <Tabs.Trigger className="TabsTrigger" value="tab1">
              Track Processes
            </Tabs.Trigger>
            <Tabs.Trigger className="TabsTrigger" value="tab2">
              Track Process Steps
            </Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content className="TabsContent" value="tab1">
            <TrackProcessList />
          </Tabs.Content>
          <Tabs.Content className="TabsContent" value="tab2">
            <TrackProcessStepList />
          </Tabs.Content>
        </Tabs.Root>
      </Flex>
    </ContainerWrapper>
  );
}

export const Route = createFileRoute("/admin/_adminLayout/")({
  component: AdminPage,
});
